export default __webpack_public_path__ + "static/media/stalltheadvance.394ea586.png";